var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-cell',{staticStyle:{"margin-top":"16px"},attrs:{"title":"更换手机号","is-link":"","value":_vm.phone},on:{"click":function($event){return _vm.changeMobile()}}}),_c('van-cell',{attrs:{"title":"注销账号","is-link":""},on:{"click":function($event){return _vm.resetAccount()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }